module.exports = __webpack_public_path__ + "img/CrimsonText-BoldItalic.d71cc8c9.svg";